export const ZPOT_PROD_URI = 'https://zpot-na-prod.zappos.com';
export const ZPOT_INTEG_URI = 'https://zpot-na.integ.zappos.com';
export const ZPOT_GAMMA_URI = 'https://potserviceui-gamma.zappos.com';
